/**
 * This mixin used for Points
 */
// widgets
import RoutePoint from '@/components/dynamic-list-items/points/RoutePoint.vue'
import AudioguidePoint from '@/components/dynamic-list-items/points/AudioguidePoint.vue'
// options
// todo: manual full mode for all options for SQL data types
// manual mode means that u can control DynamicListWrapper events not in the mixin
import Option from '@/utils/options/Option'
// new Option('Дублировать', 'duplicate', '', false, false, true),
const options = [
  new Option('Удалить', 'delete', 'borderTop', true, false, true)
]
// component export
export default {
  options,
  components: {
    RoutePoint,
    AudioguidePoint
  }
}
